module.exports = __webpack_public_path__ + "img/effectiveness_and_wellbeing.678d081c.jpg";